const teamHistories = {
  Hawks: 'The Atlanta Hawks have had a dynamic history...',
  Hornets: 'The Charlotte Hornets have had a rollercoaster journey...',
};

export default teamHistories;
